import { defineMessages } from 'react-intl';

export const socialLinkTypeIds = {
  website: 'website',
  github: 'github',
};

export const socialLinkTypeIdsOrder = [socialLinkTypeIds.website, socialLinkTypeIds.github];

export const socialLinkTypes = {
  [socialLinkTypeIds.website]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.website.name',
        defaultMessage: 'Website',
      },
    }),
    buttonClass: 'btn btn-secondary',
    iconCustomClass: 'icon--website',
    iconFaClass: 'fa fa-globe',
  },

  [socialLinkTypeIds.github]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.github.name',
        defaultMessage: 'GitHub',
      },
    }),
    domains: ['github.com', 'www.github.com'],
    buttonClass: 'btn btn-github',
    iconCustomClass: 'icon--github',
    iconFaClass: 'fa fa-github',
  },
};

export const defaultSocialLinks = socialLinkTypeIdsOrder.map(socialLinkTypeId => ({
  type: socialLinkTypeId,
  url: '',
}));

export const socialLinkTypeIdsOrderForProfile = [
  socialLinkTypeIds.website,
  socialLinkTypeIds.github,
];

export const defaultSocialLinksForProfile = socialLinkTypeIdsOrderForProfile.map(
  socialLinkTypeId => ({
    type: socialLinkTypeId,
    url: '',
  })
);



// WEBPACK FOOTER //
// ./src/ui/common/social-links/index.js